import { all } from 'redux-saga/effects';

import authSaga from './auth/auth.saga';
import contractsSaga from './contracts/contracts.saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    contractsSaga(),
  ]);
}
